export const AgeRangeType = { RANGEONE: '18-22', RANGETWO: '23-27' };
